import BeneficialOwnerUpdateModal from "./BeneficialOwnerUpdateModal"

export default BeneficialOwnerUpdateModal
